import React, { useState, useEffect } from 'react'
import { message, Modal, Skeleton, Tooltip } from "antd";
import { PlayCircleFilled, VerticalAlignBottomOutlined, CloseCircleFilled } from '@ant-design/icons';

import { useDispatch, useSelector } from "react-redux";
import { getResources } from "../store/general/actions";

const resourceList = [
  {
    name: "Add New Card",
    url: ''
  },
  {
    name: "Editing e-gift Card Template",
    url: ''
  },
  {
    name: "Uploading your design",
    url: ''
  },
  {
    name: "Creating Promotions",
    url: ''
  },
  {
    name: "Fundraising to Support the Community",
    url: ''
  },
  {
    name: "Prime Advert",
    url: ''
  }
];

const Resources = () => {
  const dispatch = useDispatch();
  const [showIframe, setshowIframe] = useState(false);
  const [current, setcurrent] = useState(0);
  const [loading, setloading] = useState(false);
  const [resourcelist, setresourcelist] = useState([]);
  const [filters] = useState({
    page: 1,
    limit: 10
  });
  const [currentItem, setcurrentItem] = useState({});

  // const onLoad = () => {
  //   setshowIframe(false);
  // }; 
  
  const handleShowVideo = (item, index) => {
    if (item.type === 'video') {
      setcurrentItem(item);
      setcurrent(index); 
      setshowIframe(true);
    }
  };
  

  useEffect(() => {
    setloading(true);
    dispatch(getResources(filters))
    .then((res) => {
      console.log('All resources:', res.resources)
      setresourcelist(res.resources);
      setloading(false);
    }, (err) => {
      console.log('Error:', err);
      message.error('Error fetching resources, please try again');
      setloading(false);
    })

    return () => {
    }
  }, []);

  return (
    <section className="p-8 min-h-half">
      <div className="mb-6">
        <h2 className="text-xl font-bold">Merchant Resource Center</h2>
        <p className="text-xs">Have access to all Prime Explainer videos, Select any of the topics and watch</p>
      </div>

      <div className="w-full flex flex-wrap">
        {resourcelist.length > 0 ?
          resourcelist.map((item, index) => (
            <div className="w-full sm:w-1/3" key={index}>
              <div className="w-full cursor-pointer mb-4 pr-6" onClick={() => { handleShowVideo(item, index)}}>
                <div className="w-full border-2 border-primary h-40 bg-gray-400 flex--basic">
                  <div className="flex--basic w-full">
                  {item?.type === 'video' &&
                    <PlayCircleFilled className="text-5xl text-white hover:transform hover:scale-105" />
                  }
                  {item?.type === 'document' &&
                    <Tooltip title="Click to download document">
                      <a className="flex--basic w-full" href={item.url} target="_blank" rel="noopener noreferrer">
                        <VerticalAlignBottomOutlined className="text-5xl text-white hover:transform hover:scale-105" />
                      </a>
                    </Tooltip>
                  }
                  </div>
                </div>
                <div className="text-base pt-2">
                  {item?.title}
                </div>
              </div>
            </div>
          ))
        :
          <div className="flex items-center justify-between w-full h-50v bg-white p-8">
              {loading ?
                [{},{},{}].map((shimmer, index) => (
                  <Skeleton.Avatar shape="square" loading={true} active className="w-full pr-6 h-40 rounded" key={index} />
                ))
              :
                <div className="flex--basic text-primary text-lg p-10 bg-white h-56 text-center w-full">No Resource Content Available Yet</div>
              }
          </div>
        }
      </div>

      <Modal
        visible={showIframe}
        className="customModal w-full flex--basic bg-transparent relative"
        footer={null}
        // closable={false}
        onCancel={() => { setshowIframe(false) }}
      >     
        {/* <div className="absolute right-0 top-0 p-4">
         <CloseCircleFilled className="text-sm cursor-pointer" onClick={()=> { setshowIframe(false) }} />
        </div> */}

        <video width="640" height="390" src={currentItem.url} className="bg-black" controls>
          Sorry, your browser doesn't support embedded videos,
          but don't worry, you can <a href={currentItem.url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Download it here</a>
          and watch it with your favorite video player!
        </video>      
      </Modal>      
    </section>
  )
}

export default Resources
